module.exports = __webpack_public_path__ + "static/assets/96edc964e2954ef3166a77f87a6cc045.png";